<template>
  <div class="container-fluid bg-dark">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="text-light  text-left mt-4 mb-3 " style="opacity: 0.92">Feature Highlights</h3>

        </div>
      </div>
    </div>
    <div class="row">

      <div class="col-12">
        <div class="my-carousel text-center ">
          <div class="position-relative overflow-hidden">
            <img  width="1691px"  class="img-fluid" src="../assets/landing/pytrace-window.png">
            <transition name="fade">
              <img v-if="slide === 2"  class="graph-overlay graph-overlay--a img-fluid" src="../assets/landing/graph-1a.png">
            </transition>
            <transition name="fade">
              <img v-if="slide === 3"   class="graph-overlay graph-overlay--b img-fluid" src="../assets/landing/graph-1b.png">
            </transition>
            <transition name="fade">

              <img v-if="slide === 4"   class="graph-overlay graph-overlay--c img-fluid" src="../assets/landing/graph-1c.png">
            </transition>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="dots  d-flex  flex-column flex-md-row align-items-center justify-content-center">

          <div v-for="x in slides" class="mt-4 dot" :class="x.index === slide ? 'dot--active' : ''" @click="set_slide(x.index)">
            <div class="dot__name p-2 pl-4 pr-4">{{x.name}}</div>
            <div class="dot__line"></div>
          </div>

        </div>
        <div class="col-12 text-center">

        <div class="text-under-carousel mb-5 mt-3">{{currentCarouselText}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'pytrace-features-carousel',
    data () {
      return {
        slide: 1,
        slides: [

          {
            name: 'Time Travel Debugger',
            index: 1,
            text: 'PyTrace is able to record and replay code events and variable state.'
          },
          {
            name: 'Call Graph',
            index: 2,
            text: 'Call Graph (G on keyboard) shows exact sequence of events, that allows to quickly learn structure of unknown code with many dependencies'
          },
          {
            name: 'Zoom into Method',
            index: 3,
            text: '[Command] + Left Mouse click allows to drill inside smallest methods'
          },
          {
            name: 'Extreme details',
            index: 4,
            text: 'You can zoom even deeper, or click [Command] + Left Mouse on outer method to leave the scope'
          }
        ]
      }
    },
    computed: {
      currentCarouselText () {
        let x = this.slides.find(_ => _.index === this.slide)
        if (x) {
          return x.text
        }
        return ''
      },
    },
    methods: {
      set_slide (index_of_slide) {
        this.slide = index_of_slide
      },
    },
  }
</script>
<style scoped>

  .graph-overlay {
    position: absolute;
    width: 1686px;
    left: 50%;
    right: 50%;
    transform: translate(-50%, 0);
    z-index: 10;
    bottom: 0;

  }
  .dot {
    cursor: pointer;
    display: inline-block;
    color: rgba(210, 210, 210, 0.88);
  }

  .dot--active {
    color: #ffffff;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }


  .dot__line {
    opacity: 0.93;
    background-color: #767676;
    height: 1px;
    width: 100%;
  }
  .dot--active .dot__line {
    background-color: #d6d6d6;

    height: 1px;
    width: 100%;
  }
  .dot__name {
    font-weight: 500;
  }
  .dot--active  .dot__name {
    font-weight: 600;
  }

  .text-under-carousel {
    color: #ffffffda;
  }
</style>